import { LinkType } from "@prismicio/types";
import { documentToLinkField } from "./documentToLinkField.js";
var asLink = function asLink(linkFieldOrDocument, linkResolver) {
  if (!linkFieldOrDocument) {
    return null;
  }
  var linkField = "link_type" in linkFieldOrDocument ? linkFieldOrDocument : documentToLinkField(linkFieldOrDocument);
  switch (linkField.link_type) {
    case LinkType.Media:
    case LinkType.Web:
      return "url" in linkField ? linkField.url : null;
    case LinkType.Document:
      {
        if ("id" in linkField && linkResolver) {
          var resolvedURL = linkResolver(linkField);
          if (resolvedURL != null) {
            return resolvedURL;
          }
        }
        if ("url" in linkField && linkField.url) {
          return linkField.url;
        }
        return null;
      }
    case LinkType.Any:
    default:
      return null;
  }
};
export { asLink };